import { media } from '@/styles/Qtheme';
import styled from 'styled-components';

export const Description = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.6;
  color: #e9e9ed;
  letter-spacing: -0.3px;
  padding: 40px 0;

  p {
    margin: 0;

    &:first-child {
      margin-bottom: 24px;
      line-height: 1.7;
      color: #b3b5bd;

      @media ${media.mobile} {
        margin-bottom: 16px;
      }
    }

    &:not(:first-child) {
      margin-bottom: 12px;
      padding-left: 8px;
      position: relative;

      @media ${media.mobile} {
        margin-bottom: 8px;
      }

      &::before {
        content: '•';
        position: absolute;
        left: -12px;
        color: #6c6e7a;
        font-weight: bold;

        @media ${media.mobile} {
          left: -4px;
        }
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media ${media.mobile} {
    font-size: 14px;
    padding: 20px 0;
  }
`;
